import { useEffect, useContext } from 'react';
import { useNavigate, Outlet } from 'react-router';

import { ClinicRxContext } from './App';
import SocketProvider from './socket/SocketProvider';
import RealTimeDataProvider from './socket/RealTimeDataProvider';

export default function ProtectedRoute({}) {
  const navigate = useNavigate();
  const { state } = useContext(ClinicRxContext);

  useEffect(() => {
    if (!state.user.isAuthenticated) {
      navigate('/');
    }
  }, [state.user]);

  if (!state.user.isAuthenticated) return null;
  return (
    <SocketProvider>
      <RealTimeDataProvider
        render={(props) => {
          return <Outlet context={props} />;
        }}
      />
    </SocketProvider>
  );
}
